// Import ag-grid-enterprise first to auto-register all enterprise modules
import 'ag-grid-enterprise'
import { useAuth } from '@/contexts/AuthContext'
import { useTenantStore } from '@/stores/tenantStore'
import { LicenseManager } from 'ag-grid-enterprise'
import { useEffect } from 'react'
import { initializePendo } from './pendo'

// Initialize AG-Grid Enterprise license
// This is the same license key used in bb_frontend and excalibrr
LicenseManager.setLicenseKey(
  'Using_this_AG_Grid_Enterprise_key_( AG-050987 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( capSpire )_is_granted_a_( Multiple Applications )_Developer_License_for_( 3 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 8 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 17_December_2024 )____[v2]_MTczNDM5MzYwMDAwMA==97e04a13d661cd40e68a78abfaa164d0',
)

// Used to set up any auth dependent integrations like Pendo. Called in Main.tsx to ensure it runs on app load and whenever auth state changes.
export function useIntegrationSetup() {
  const { user } = useAuth()
  const { selectedTenant } = useTenantStore()

  useEffect(() => {
    if (user && selectedTenant) {
      initializePendo(user.email, selectedTenant?.name)
    }
  }, [user])
}
